import React, { useCallback, useEffect, useState } from "react";
import FormInputField from "../common-components/FormInputField";
import { StyledGrid } from "../../pages/incorporation/Incorporation";
import Grid from "@mui/material/Grid2";
import { useFormik } from "formik";
import { StyledTypographyLLc } from "../style/modalStyleLarge";
import UploadFileFieldNew from "../common-components/UploadFileFieldNew";
import { UploadIcon } from "../../assets/Icon/dashboredIcon";
import { PhoneIcon } from "../../assets/Icon/LlcForm";
import SelectInputField from "../common-components/SelectInputField";
import { useSelector } from "react-redux";
import { Typography, Box, CircularProgress } from "@mui/material";
import CustomButton from "../common-components/CustomButton";
import UploadMultipleFile from "../common-components/UploadMultipleFile";
import { businessExpenses, personalIncomeFields } from "../../utils/constants";
import { SinglememberFormSchema } from "../../form-schema";
import TitleBar from "../common-components/TitleBar";
import { StyleDiv } from "../../pages/orderMember/singleMember";
import { StyledButton } from "../style/ititn/DeatilStyle";
import CopyModel from "./CopyModel";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import theme from "../../theme";
import {
  deleteUploadedDocument,
  getTaxFilingData,
  getTaxFilingDataById,
  uploadTaxFilingForm,
} from "../../stores/taxfiling";
import { useDispatch } from "react-redux";
import { getCountryList } from "../../stores/incorporation";
import BackPageButton from "../common-components/BackPageButton";
import ListLoadingNew from "../common-components/ListLoadingNew";
import { setToast } from "../../stores/toast/toastslice";
import DatePickerField from "../common-components/DatePickerField";

const SinglememberForm = () => {
  const navigate = useNavigate();
  const [filePreview, setFilePreview] = useState<string | null>(null);
  const [einPreviews, setEinPreviews] = useState<string | null>(null);
  const [itinPreviews, setItinPreviews] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const [pageload, setPageLoad] = useState(true);
  const [filePreviews, setFilePreviews] = useState<string[]>([]);
  const [isTaxModalOpen, setIsTaxModalOpen] = useState(false);
  const [isSavingDraft, setIsSavingDraft] = useState(false);
  const [companyDocuments, setCompanyDocuments] = useState<any[]>([]);
  const [einDocuments, setEinDocuments] = useState<any[]>([]);
  const [itinDocuments, setItinDocuments] = useState<any[]>([]);
  const [isFileDeleted, setIsFileDeleted] = useState(false);
  const location = useLocation();
  const { id: ID } = useParams();
  const isReturn = location.state?.isReturn;
  const { countryList } = useSelector((store: any) => store.incorporation);
  const { taxfillingOrderList, taxFilingDataReview, reviewStatus } =
    useSelector((state: any) => state.taxfiling);
  console.log(taxFilingDataReview, "taxFilingDataReview");
  const newfetchListOrder = taxfillingOrderList?.tax_filing_files_list;
  // Prefer review object if available

  const fetchListOrder =
    newfetchListOrder?.length > 1
      ? taxFilingDataReview && taxFilingDataReview?.tax_filing_file?.file_data
      : newfetchListOrder && newfetchListOrder[0]?.file_data;

  const documentsNew =
    newfetchListOrder?.length > 1
      ? taxFilingDataReview && taxFilingDataReview?.documents_by_type
      : newfetchListOrder && newfetchListOrder[0]?.documents;

  // Prefer id from review object when present
  const taxFilingId =
    taxFilingDataReview?.tax_filing_file?.id ||
    (newfetchListOrder?.length ? newfetchListOrder[0]?.id : null);
  const taxFilingOrderId =
    taxFilingDataReview?.tax_filing_file?.order_item_id ||
    (newfetchListOrder?.length ? newfetchListOrder[0]?.order_item_id : null);
  // console.log(taxFilingDataReview?.tax_filing_file, "taxFilingId");
  const dispatch = useDispatch();
  const id = ID || taxFilingId;
  // console.log(id,taxFilingId, "id,taxFilingId");

  const getTaxFilingListId = useCallback(async () => {
    if (!ID) return;
    const payload = {
      tax_filing_file_id: ID || taxFilingId,
    };
    await dispatch<any>(getTaxFilingDataById(payload)).then(
      async (res: any) => {
        if (res?.payload?.status >= 400) {
          await dispatch<any>(
            setToast({
              message:
                res?.payload?.data?.message ||
                (typeof res?.payload?.data?.message === "string" &&
                  res?.payload?.data?.message) ||
                "Something went wrong!",
              type: "error",
              title: "Error",
            }),
          );
          const timeout = setTimeout(() => {
            navigate("/tools/tax-filing");
          }, 2000);

          return () => clearTimeout(timeout);
        }
        setLoading(false);
      },
    );
  }, [dispatch, id]);
  useEffect(() => {
    getTaxFilingListId();
  }, [id]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 3000);

    return () => clearInterval(timeout);
  }, []);

  useEffect(() => {
    // Fetch country list if it's empty
    if (countryList.length === 0) {
      dispatch<any>(getCountryList({}));
    }
  }, [countryList.length, dispatch]);

  const getTaxFilingList = useCallback(async () => {
    // setLoading(true);
    const payload = {
      offset: 0,
      limit: 10,
    };
    const result = await dispatch<any>(getTaxFilingData(payload));
  }, [dispatch, isReturn, navigate, newfetchListOrder, id]);
  useEffect(() => {
    getTaxFilingList();
  }, []);
  // Add this new useEffect to populate form data
  useEffect(() => {
    if (fetchListOrder) {
      const formData = fetchListOrder as any;
      const documents = documentsNew as any;

      // Combine country_code and phone_number for the phone field
      // const phoneValue = formData?.phone_number
      //   ? `${formData?.phone_number}`
      //   : formData?.phone_number || "";

      // Set all form values
      formik.setValues({
        // Personal Information
        name_surname: formData.name_surname || "",
        email: formData.email || "",
        date_of_birth: formData.date_of_birth || "",
        phone_number: formData?.phone_number,
        country_code: formData?.country_code,
        country: formData.country || "",

        // Business Details
        working_outside_us: formData.working_outside_us || "",
        working_within_us: formData.working_within_us || "",
        business_address: formData.business_address || "",
        nature_of_business: formData.nature_of_business || "",

        passport_scan:
          (taxFilingDataReview?.tax_filing_file as any)?.passport ||
          (taxfillingOrderList?.tax_filing_files_list[0]?.passport ?? ""),
        // File uploads - keep as null for now, handle separately
        company_formation_document: documents?.company || [],
        ein_document: documents?.ein || [], // Don't set existing documents as file objects - they're not File instances
        itin_document: documents?.itin || [],

        // Business Income
        gross_income: formData.gross_income || "",
        personal_gross_income: formData.personal_gross_income || "",
        amount_of_returns: formData.amount_of_returns || "",
        cost_of_goods_sold: formData.cost_of_goods_sold || "",

        // Business Expenses
        advertising: formData.advertising || "",
        commissions_fees: formData.commissions_fees || "",
        contract_labor: formData.contract_labor || "",
        legal_professional: formData.legal_professional || "",
        pension_profit_sharing: formData.pension_profit_sharing || "",
        rent_lease_vehicles: formData.rent_lease_vehicles || "",
        repairs_maintenance: formData.repairs_maintenance || "",
        supplies_materials: formData.supplies_materials || "",
        supplies_stationary: formData.supplies_stationary || "",
        taxes_licenses: formData.taxes_licenses || "",
        travel_meals: formData.travel_meals || "",
        utilities: formData.utilities || "",
        wages: formData.wages || "",
        other_business: formData.other_business || "",
        insurance: formData.insurance || "",
        interest_bank: formData.interest_bank || "",
        office_expenses: formData.office_expenses || "",

        // Personal Income
        interest_income: formData.interest_income || "",
        tax_exempt_interest: formData.tax_exempt_interest || "",
        qualified_dividends: formData.qualified_dividends || "",
        scholarship_fellowship_grants:
          formData.scholarship_fellowship_grants || "",
        taxable_refunds: formData.taxable_refunds || "",
        capital_gain_loss: formData.capital_gain_loss || "",
        other_gains_losses: formData.other_gains_losses || "",
        ira_distributions: formData.ira_distributions || "",
        pensions_annuities: formData.pensions_annuities || "",
        farm_income_loss: formData.farm_income_loss || "",
        unemployment_compensation: formData.unemployment_compensation || "",
        other_income: formData.other_income || "",

        // Contributions and Distributions
        total_contributions: formData.total_contributions || "",
        total_distributions: formData.total_distributions || "",
      });

      // Handle file previews for existing documents from the documents object
      if (documents?.company && Array.isArray(documents.company)) {
        const companyDocPreviews = documents.company.map(
          (doc: any) => doc.document_file_url,
        );
        setFilePreviews(companyDocPreviews);
        console.log("Company documents:", companyDocPreviews);
      }

      if (
        documents?.ein &&
        Array.isArray(documents.ein) &&
        documents.ein.length > 0
      ) {
        // Take only the first EIN document since we now support single file
        const firstEinDoc = documents.ein[0];
        const einDocPreview = firstEinDoc.document_file_url;
        setEinPreviews(einDocPreview);
        console.log("EIN document:", einDocPreview);
      }

      // Handle ITIN documents
      if (documents?.itin && Array.isArray(documents.itin)) {
        const itinDocUrls = documents.itin.map(
          (doc: any) => doc.document_file_url,
        );
        setItinPreviews(itinDocUrls);
        console.log("ITIN documents:", itinDocUrls);
      }

      // Handle passport preview if available
      const getPassportUrl = () => {
        return (
          (taxFilingDataReview?.tax_filing_file as any)?.passport ||
          taxfillingOrderList?.tax_filing_files_list[0]?.passport
        );
      };

      const passportUrl = getPassportUrl();
      if (passportUrl) {
        // Extract filename from URL for display
        const filename = passportUrl || "passport.pdf";
        formik.setFieldValue("passport_scan", passportUrl);
        setFilePreview(filename);
        console.log("Passport URL:", passportUrl);
        console.log("Extracted filename:", filename);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchListOrder, navigate, id]);

  // Initialize file previews when documents are loaded
  useEffect(() => {
    if (documentsNew?.company && Array.isArray(documentsNew.company)) {
      // Set the actual document objects with IDs
      setCompanyDocuments(documentsNew.company);

      const companyFileNames = documentsNew.company.map(
        (doc: any) => doc.document_file_url || doc.name || "Unknown file",
      );
      setFilePreviews(companyFileNames);
      console.log("Initialized company file previews:", companyFileNames);
      console.log("Initialized company documents:", documentsNew.company);
    }

    // Initialize EIN documents
    if (documentsNew?.ein && Array.isArray(documentsNew.ein)) {
      setEinDocuments(documentsNew.ein);
    }

    // Initialize ITIN documents
    if (documentsNew?.itin && Array.isArray(documentsNew.itin)) {
      setItinDocuments(documentsNew.itin);
    }
  }, [documentsNew?.company, documentsNew?.ein, documentsNew?.itin]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setPageLoad(false);
    }, 3000);

    return clearTimeout(timeout);
  }, []);

  // const memberFormhandling = async (
  //   values: any,
  //   saveAsDraft: boolean = true,
  //   isDraft: boolean = false,
  // ) => {
  //   // console.log(values.passport_scan ,"values.passport_scan");
  //   // Set loaders based on saveAsDraft parameter
  //   if (saveAsDraft) {
  //     setIsSavingDraft(true);
  //   } else {
  //     setLoading(true);
  //   }

  //   const formData = new FormData();

  //   // Create a copy of values to modify for file_data (JSON string)
  //   const formDataForJson = { ...values };

  //   // Remove file fields from the JSON payload, as they are sent separately
  //   delete formDataForJson.passport_scan;
  //   delete formDataForJson.company_formation_document;
  //   delete formDataForJson.ein_document;
  //   delete formDataForJson.itin_document;

  //   // Append standard fields to FormData (as strings)
  //   formData.append("tax_filing_file_id", id || taxFilingId);
  //   formData.append("step", isDraft ? "0" : "1");
  //   formData.append("save_as_draft", saveAsDraft ? "true" : "false");
  //   // formData.append('country_code', values.country_code || '');
  //   // formData.append('phone_number', values.phone_number || '');

  //   // Append the JSON string of the remaining form data
  //   formData.append("file_data", JSON.stringify(formDataForJson));

  //   // Debug: Log file information before processing

  //   // Handle passport (can be File or string)
  //   if (values.passport_scan instanceof File) {
  //     console.log("Adding passport file:", values.passport_scan.name);
  //     formData.append("passport", values.passport_scan);
  //   } else if (typeof values.passport_scan === "string") {
  //     console.log("Adding passport string URL:", values.passport_scan);
  //     formData.append("passport_string", values.passport_scan);
  //   } else {
  //     console.log("No valid passport_scan found");
  //   }

  //   // Handle company documents (can be array of Files or array of { document_file_url: string })
  //   if (Array.isArray(values.company_formation_document)) {
  //     console.log(
  //       "Processing company_formation_document array with",
  //       values.company_formation_document.length,
  //       "items",
  //     );

  //     values.company_formation_document.forEach((item: any, index: number) => {
  //       // If it's a File

  //       console.log(item, "item");
  //       if (item instanceof File) {
  //         console.log(`Adding company_formation_document (File): ${item.name}`);
  //         formData.append("company_formation_document", item);
  //       }
  //       // If it's an object with document_file_url
  //       else if (item && typeof item === "object" && item.document_file_url) {
  //         console.log(
  //           `Adding company_formation_document (URL string): ${item.document_file_url}`,
  //         );
  //         formData.append(
  //           "company_formation_document_string",
  //           item.document_file_url,
  //         );
  //       }
  //       // If it's a plain string
  //       else if (typeof item === "string") {
  //         console.log(`Adding company_formation_document (string): ${item}`);
  //         formData.append("company_formation_document_string", item);
  //       }
  //     });
  //   } else {
  //     console.log("No company_documents found or not an array");
  //   }

  //   // Handle EIN (single File or array with File/string)
  //   if (values.ein_document) {
  //     if (values.ein_document instanceof File) {
  //       console.log("Adding EIN document (File):", values.ein_document.name);
  //       formData.append("ein_document", values.ein_document);
  //     } else if (Array.isArray(values.ein_document)) {
  //       const firstItem = values.ein_document[0];
  //       if (firstItem instanceof File) {
  //         console.log(`Adding EIN document (first File): ${firstItem.name}`);
  //         formData.append("ein_document", firstItem);
  //       } else if (
  //         firstItem &&
  //         typeof firstItem === "object" &&
  //         firstItem.document_file_url
  //       ) {
  //         console.log(
  //           `Adding EIN document (URL string): ${firstItem.document_file_url}`,
  //         );
  //         formData.append("ein_document_string", firstItem.document_file_url);
  //       } else if (typeof firstItem === "string") {
  //         console.log("Adding EIN document (string):", firstItem);
  //         formData.append("ein_document_string", firstItem);
  //       }
  //     } else if (typeof values.ein_document === "string") {
  //       console.log("Adding EIN document (string):", values.ein_document);
  //       formData.append("ein_document_string", values.ein_document);
  //     }
  //   } else {
  //     console.log("No EIN document found");
  //   }

  //   // Handle ITIN documents (array of Files or array of { document_file_url: string })
  //   if (Array.isArray(values.itin_document)) {
  //     console.log(
  //       "Processing itin_document array with",
  //       values.itin_document.length,
  //       "items",
  //     );

  //     values.itin_document.forEach((item: any, index: number) => {
  //       if (item instanceof File) {
  //         console.log(`Adding ITIN document (File): ${item.name}`);
  //         formData.append("itin_document", item);
  //       } else if (item && typeof item === "object" && item.document_file_url) {
  //         console.log(`Adding ITIN document (URL): ${item.document_file_url}`);
  //         formData.append("itin_document_string", item.document_file_url);
  //       } else if (typeof item === "string") {
  //         console.log(`Adding ITIN document (string): ${item}`);
  //         formData.append("itin_document_string", item);
  //       }
  //     });
  //   } else {
  //     console.log("No ITIN documents found or not an array");
  //   }

  //   // Debug: Log FormData contents

  //   const formDataEntries = Array.from(formData.entries());
  //   formDataEntries.forEach((pair) => {
  //     console.log(
  //       pair[0] +
  //         ": " +
  //         (pair[1] instanceof File ? `File: ${pair[1].name}` : pair[1]),
  //     );
  //   });

  //   const result = await dispatch<any>(uploadTaxFilingForm(formData));

  //   // Reset loaders immediately after API call
  //   if (saveAsDraft) {
  //     setIsSavingDraft(false);
  //   } else {
  //     setLoading(false);
  //   }

  //   if (result?.payload?.status === 1) {
  //     if (isDraft) {
  //       dispatch<any>(
  //         setToast({
  //           message: "Data is saved as draft!",
  //           type: "success",
  //           title: "Success",
  //           onClose: () => {},
  //         }),
  //       );
  //       return;
  //     }

  //     if (taxfillingOrderList?.tax_filing_files_list?.length === 1 && isDraft) {
  //       // Show success message for draft save
  //       dispatch<any>(
  //         setToast({
  //           message: "Data is saved as draft!",
  //           type: "success",
  //           title: "Success",
  //           onClose: () => {},
  //         }),
  //       );

  //       // Don't reload data to prevent form from resetting
  //       // User can refresh page manually if they want to see updated draft
  //     } else if (
  //       taxfillingOrderList?.tax_filing_files_list?.length > 1 &&
  //       isDraft
  //     ) {
  //       navigate("/tools/tax-filing/list");
  //     } else {
  //       navigate(`/tools/tax-filing/review/${id}`, {
  //         state: {
  //           taxFilingId: id,
  //           formData: values,
  //           documents: {
  //             company: values.company_formation_document,
  //             ein: values.ein_document,
  //             itin: values.itin_document,
  //           },
  //         },
  //       });
  //     }
  //   }
  // };

  const memberFormhandling = async (
    values: any,
    saveAsDraft: boolean = true,
    isDraft: boolean = false,
  ) => {
    if (saveAsDraft) {
      setIsSavingDraft(true);
    } else {
      setLoading(true);
    }

    try {
      const formData = new FormData();

      // Create JSON copy without file fields
      const formDataForJson = { ...values };

      delete formDataForJson.passport_scan;
      delete formDataForJson.company_formation_document;
      delete formDataForJson.ein_document;
      delete formDataForJson.itin_document;

      // Standard fields
      formData.append("tax_filing_file_id", id || taxFilingId);
      formData.append("step", isDraft ? "0" : "1");
      formData.append("save_as_draft", saveAsDraft ? "true" : "false");

      // JSON payload
      formData.append("file_data", JSON.stringify(formDataForJson));

      // Passport
      if (values.passport_scan instanceof File) {
        formData.append("passport", values.passport_scan);
      } else if (typeof values.passport_scan === "string") {
        formData.append("passport_string", values.passport_scan);
      }

      // Company formation documents
      if (Array.isArray(values.company_formation_document)) {
        values.company_formation_document.forEach((item: any) => {
          if (item instanceof File) {
            formData.append("company_formation_document", item);
          } else if (
            item &&
            typeof item === "object" &&
            item.document_file_url
          ) {
            formData.append(
              "company_formation_document_string",
              item.document_file_url,
            );
          } else if (typeof item === "string") {
            formData.append("company_formation_document_string", item);
          }
        });
      }

      // EIN document
      if (values.ein_document) {
        if (values.ein_document instanceof File) {
          formData.append("ein_document", values.ein_document);
        } else if (Array.isArray(values.ein_document)) {
          const firstItem = values.ein_document[0];

          if (firstItem instanceof File) {
            formData.append("ein_document", firstItem);
          } else if (
            firstItem &&
            typeof firstItem === "object" &&
            firstItem.document_file_url
          ) {
            formData.append("ein_document_string", firstItem.document_file_url);
          } else if (typeof firstItem === "string") {
            formData.append("ein_document_string", firstItem);
          }
        } else if (typeof values.ein_document === "string") {
          formData.append("ein_document_string", values.ein_document);
        }
      }

      // ITIN documents
      if (Array.isArray(values.itin_document)) {
        values.itin_document.forEach((item: any) => {
          if (item instanceof File) {
            formData.append("itin_document", item);
          } else if (
            item &&
            typeof item === "object" &&
            item.document_file_url
          ) {
            formData.append("itin_document_string", item.document_file_url);
          } else if (typeof item === "string") {
            formData.append("itin_document_string", item);
          }
        });
      }

      // Debug FormData
      const formDataEntries = Array.from(formData.entries());

      formDataEntries.forEach((pair) => {
        console.log(
          pair[0] +
            ": " +
            (pair[1] instanceof File ? `File: ${pair[1].name}` : pair[1]),
        );
      });

      // API Call
      const result = await dispatch<any>(uploadTaxFilingForm(formData));
      console.log(result, "API result");
      // Stop loaders
      if (saveAsDraft) {
        setIsSavingDraft(false);
      } else {
        setLoading(false);
      }

      // ERROR HANDLING
      if (result?.type?.includes("rejected")) {
        dispatch<any>(
          setToast({
            message: result?.payload?.data?.message || "Something went wrong",
            type: "error",
            title: "Error",
            onClose: () => {},
          }),
        );

        return;
      }

      // SUCCESS HANDLING
      if (result?.payload?.status === 1) {
        if (isDraft) {
          dispatch<any>(
            setToast({
              message: "Data is saved as draft!",
              type: "success",
              title: "Success",
              onClose: () => {},
            }),
          );

          return;
        }

        if (
          taxfillingOrderList?.tax_filing_files_list?.length === 1 &&
          isDraft
        ) {
          dispatch<any>(
            setToast({
              message: "Data is saved as draft!",
              type: "success",
              title: "Success",
              onClose: () => {},
            }),
          );
        } else if (
          taxfillingOrderList?.tax_filing_files_list?.length > 1 &&
          isDraft
        ) {
          navigate("/tools/tax-filing/list");
        } else {
          navigate(`/tools/tax-filing/review/${id}`, {
            state: {
              taxFilingId: id,
              formData: values,
              documents: {
                company: values.company_formation_document,
                ein: values.ein_document,
                itin: values.itin_document,
              },
            },
          });
        }
      }
    } catch (error) {
      console.error("Form submit error:", error);

      dispatch<any>(
        setToast({
          message: "Something went wrong",
          type: "error",
          title: "Error",
          onClose: () => {},
        }),
      );

      if (saveAsDraft) {
        setIsSavingDraft(false);
      } else {
        setLoading(false);
      }
    }
  };
  const formik: any = useFormik({
    initialValues: {
      // Personal Information
      name_surname: "",
      email: "",
      date_of_birth: "",
      phone_number: "",
      country_code: fetchListOrder?.country_code || "",
      country: "",

      // Business Details
      working_outside_us: "",
      working_within_us: "",
      business_address: "",
      nature_of_business: "",

      // File uploads
      passport_scan: "",
      company_formation_document: [],
      ein_document: "",
      itin_document: [],
      passport_scan_string: "",
      ein_document_string: "",
      itin_document_string: "",
      company_formation_document_string: "",

      // Business Income
      gross_income: "",
      personal_gross_income: "",
      cost_of_goods_sold: "",

      // Business Expenses
      advertising: "",
      commissions_fees: "",
      contract_labor: "",
      legal_professional: "",
      pension_profit_sharing: "",
      rent_lease_vehicles: "",
      repairs_maintenance: "",
      supplies_materials: "",
      supplies_stationary: "",
      taxes_licenses: "",
      travel_meals: "",
      utilities: "",
      wages: "",
      other_business: "",

      // Personal Income
      interest_income: "",
      tax_exempt_interest: "",
      qualified_dividends: "",
      scholarship_fellowship_grants: "",
      taxable_refunds: "",
      capital_gain_loss: "",
      other_gains_losses: "",
      ira_distributions: "",
      pensions_annuities: "",
      farm_income_loss: "",
      unemployment_compensation: "",
      other_income: "",

      // Contributions and Distributions
      total_contributions: "",
      total_distributions: "",

      // Add these missing fields in the Business Expenses section
      insurance: "",
      interest_bank: "",
      office_expenses: "",
    },
    validationSchema: SinglememberFormSchema,
    onSubmit: async (values) => {
      await memberFormhandling(values, true);
      // navigate("/tools/tax-filing/review");
    },
    validateOnChange: true,
    validateOnBlur: true,
  });

  const handleFileChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    fieldName: string,
    setPreview: (url: string | null) => void,
  ) => {
    const file = e.target.files?.[0] || null;
    formik.setFieldValue(fieldName, file);
    if (file) {
      const previewURL = URL.createObjectURL(file);
      setPreview(previewURL);
    } else {
      setPreview("");
    }
  };
  const handleTaxModalClose = () => {
    setIsTaxModalOpen(false);
  };
  // console.log(formik.errors, "formik.errors");
  const handleSaveAsDraft = async () => {
    // console.log("handleSaveAsDraft");
    // Validate at least some fields are filled before saving as draft
    if (!formik.values.name_surname && !formik.values.email) {
      //  alert("Please fill in at least Name and Email before saving as draft");
      return;
    }
    try {
      // Call the submission handler with saveAsDraft flag
      await memberFormhandling(formik.values, true, true);
    } catch (error) {
      console.error("Error saving draft:", error);
      //  alert("Failed to save draft. Please try again.");
    }
  };
  if (pageload) {
    <ListLoadingNew />;
  }
  const handleDeleteUploadedDocument = async (
    index: number,
    documentType: "company" | "ein" | "itin",
  ) => {
    let documents: any[] = [];
    let setDocuments: any;
    let setPreviews: any;

    // Determine which document array to use based on type
    if (documentType === "company") {
      documents = companyDocuments;
      setDocuments = setCompanyDocuments;
      setPreviews = setFilePreviews;
    } else if (documentType === "ein") {
      documents = einDocuments;
      setDocuments = setEinDocuments;
      setPreviews = setEinPreviews;
    } else if (documentType === "itin") {
      documents = itinDocuments;
      setDocuments = setItinDocuments;
      setPreviews = setItinPreviews;
    }

    // Get the actual document at this index
    const documentToDelete = documents[index];

    // Check if document has an ID (existing document from server)
    if (documentToDelete && documentToDelete.id) {
      console.log("Deleting document with ID:", documentToDelete.id);

      try {
        setIsFileDeleted(true);
        // Call API to delete
        const result = await dispatch<any>(
          deleteUploadedDocument(documentToDelete.id),
        );

        getTaxFilingListId(); // Refresh data after deletion

        if (result?.payload?.status === 1) {
          // Remove from local state
          const updatedDocuments = documents.filter((_, i) => i !== index);
          setDocuments(updatedDocuments);

          // Update previews
          const baseUrl = process.env.REACT_APP_BASE_IMAGE_URL || "";
          setPreviews(
            updatedDocuments.map(
              (doc: any) => `${baseUrl}${doc.document_file_url}`,
            ),
          );

          dispatch<any>(
            setToast({
              message:
                result?.payload?.message || "Document deleted successfully!",
              type: "success",
              title: "Success",
            }),
          );
        }
      } catch (error) {
        console.error("Error deleting document:", error);
        dispatch<any>(
          setToast({
            message: "Failed to delete document. Please try again.",
            type: "error",
            title: "Error",
          }),
        );
      } finally {
        setIsFileDeleted(false);
      }
    } else {
      // Handle local state deletion (for newly uploaded files without ID)
      console.log("Deleting local document at index:", index);

      // Remove from local state
      const updatedDocuments = documents.filter((_, i) => i !== index);
      setDocuments(updatedDocuments);

      // Update previews
      const baseUrl = process.env.REACT_APP_BASE_IMAGE_URL || "";
      setPreviews(
        updatedDocuments.map(
          (doc: any) => `${baseUrl}${doc.document_file_url || doc}`,
        ),
      );

      // Update formik values
      if (documentType === "company") {
        formik.setFieldValue("company_formation_document", updatedDocuments);
      } else if (documentType === "ein") {
        formik.setFieldValue("ein_document", updatedDocuments);
      } else if (documentType === "itin") {
        formik.setFieldValue("itin_document", updatedDocuments);
      }

      dispatch<any>(
        setToast({
          message: "Document removed successfully!",
          type: "success",
          title: "Success",
        }),
      );
    }
  };

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </div>
    );
  }

  return (
    <>
      {/* Debug section - remove in production */}
      {taxfillingOrderList?.tax_filing_files_list?.length > 1 && (
        <BackPageButton title="Orders" />
      )}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <TitleBar
          title="Intake from the single member LLC tax filing form"
          isSpan={true}
          spanText="Form1/Form2"
        />

        <StyleDiv>
          <StyledButton
            sx={{ marginRight: "10px" }}
            variant="outlined"
            color="primary"
            onClick={handleSaveAsDraft}
            disabled={isSavingDraft}
          >
            {isSavingDraft ? (
              <CircularProgress size={16} sx={{ color: "#fff" }} />
            ) : (
              "Save As Draft"
            )}
          </StyledButton>
          <StyledButton
            variant="outlined"
            color="primary"
            onClick={() => setIsTaxModalOpen(true)}
          >
            Copy
          </StyledButton>
        </StyleDiv>
      </div>

      <Typography
        variant="body1"
        sx={{
          paddingY: "30px",
          color: "#666",
          wordBreak: "break-word",
          overflowWrap: "break-word",
          maxWidth: "100%",
        }}
      >
        Dear taxpayer, below is our simple tax filing form, if you need help
        with the form and if you don't know your options please don't hesitate
        to book a call here:
        <br />
        <a
          href="https://calendly.com/theitin/30min?month=2024-11"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#2977CC",
            wordBreak: "break-all",
            overflowWrap: "break-word",
          }}
        >
          https://calendly.com/theitin/30min?month=2024-11
        </a>
        <br />
        Please write your name and surname and TAX CONSULTATION on the
        description while booking.
      </Typography>
      {/* {status === "loading" ? <ListLoadingNew />: */}

      <form onSubmit={formik.handleSubmit}>
        <StyledGrid
          container
          spacing={3}
          style={{ width: "100%", minHeight: "auto" }}
        >
          {/* PERSONAL INFORMATION */}

          <Grid size={{ xs: 12, md: 12 }}>
            <StyledTypographyLLc isFont={true}>
              PERSONAL INFORMATION
            </StyledTypographyLLc>
            <FormInputField
              placeholder="Enter name and surname"
              formik={formik}
              name="name_surname"
              label="Name and Surname"
            />
          </Grid>

          <Grid size={{ xs: 12, md: 12 }}>
            <StyledTypographyLLc isFont={true}>
              Please upload your passport scan to prevent any mistakes for the
              correct information of your Full Name.
            </StyledTypographyLLc>
            <Box>
              <Typography
                sx={{
                  color: theme.palette.myCustomColor.dark,
                  marginBottom: "10px",
                }}
                variant="h4"
              >
                Passport Scan{" "}
                <span
                  style={{ color: "#666", fontSize: "12px", marginLeft: "3px" }}
                >
                  (optional)
                </span>
              </Typography>

              <UploadFileFieldNew
                title={""}
                icon={<UploadIcon />}
                name="passport_scan"
                formik={formik}
                handleFileChange={(e) =>
                  handleFileChange(e, "passport_scan", setFilePreview)
                }
                setFilePreview={setFilePreview}
                filePreview={filePreview}
                // showInstruction
              />
            </Box>
          </Grid>

          <Grid size={{ xs: 12, md: 12 }}>
            <FormInputField
              placeholder=""
              formik={formik}
              name="email"
              label="E-Mail"
            />
          </Grid>

          <Grid size={{ xs: 12, md: 12 }}>
            {/* <FormInputField
              placeholder="Enter place of birth"
              formik={formik}
              name="place_of_birth"
              label="Place of Birth"
            /> */}
            <DatePickerField
              label="Date of Birth"
              placeholder="Enter date of birth"
              formik={formik}
              name="date_of_birth"
            />
          </Grid>

          <Grid size={{ xs: 12, md: 12 }}>
            <FormInputField
              placeholder="Enter phone number"
              formik={formik}
              name="phone_number"
              icon={<PhoneIcon />}
              isPhnNo={true}
              label="Phone"
            />
            <Typography
              variant="caption"
              sx={{ color: "#666", fontSize: "12px" }}
            >
              Include Country Code
            </Typography>
          </Grid>

          <Grid size={{ xs: 12, md: 12 }}>
            <SelectInputField
              formik={formik}
              placeholder="Select Country"
              label="Country"
              menuData={countryList}
              name="country"
              sendValue
            />
          </Grid>
          {/* BUSINESS DETAILS */}

          <Grid size={{ xs: 12, md: 12 }}>
            <StyledTypographyLLc isFont={true}>
              BUSINESS DETAILS
            </StyledTypographyLLc>
            <StyledTypographyLLc isFont={true}>Option 1:</StyledTypographyLLc>
            <SelectInputField
              formik={formik}
              placeholder="Nothing selected"
              label=""
              menuData={[
                { id: 1, name: "Yes", value: "Yes" },
                { id: 2, name: "No", value: "No" },
              ]}
              name="working_outside_us"
            />
            <Typography
              variant="body1"
              sx={{ color: "#666", fontSize: "14px" }}
            >
              I own a single-member LLC, I'm not physically based in the US, I'm
              in a Tax Treaty country and since single-member LLCs income is m y
              direct income, I want to take advantage on taxes, and I only want
              to report 5472+1120 proforma to show the money exchange between my
              country and my pocket with my US entity, and tell the IRS that I
              'm a taxpayer in my country, so I would not pay a percentage off
              my profit for my entity.
            </Typography>
            <a
              href="https://www.irs.gov/businesses/international-businesses/united-states-income-tax-treaties-a-to-z"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#2977CC", fontSize: "14px" }}
            >
              https://www.irs.gov/businesses/international-businesses/united-states-income-tax-treaties-a-to-z
            </a>
          </Grid>

          <Grid size={{ xs: 12, md: 12 }}>
            <StyledTypographyLLc isFont={true}>Option 2:</StyledTypographyLLc>
            <SelectInputField
              formik={formik}
              placeholder="Nothing selected"
              label=""
              menuData={[
                { id: 1, name: "Yes", value: "Yes" },
                { id: 2, name: "No", value: "No" },
              ]}
              name="working_within_us"
            />
            <Typography
              variant="body1"
              sx={{ color: "#666", fontSize: "14px" }}
            >
              I want to file 1040NR and pay a percentage off the profit I make
              since i think long-term US operations and activities with my
              business(ie:I may apply for business related visas, immigrate, get
              acquired, go for VC). (Common option)
            </Typography>
          </Grid>

          <Grid size={{ xs: 12, md: 12 }}>
            <StyledTypographyLLc isFont={true}>
              Company Documents
            </StyledTypographyLLc>
            <UploadMultipleFile
              title={""}
              placeholder="Upload Documents"
              name="company_formation_document"
              formik={formik}
              icon={<UploadIcon />}
              filePreviews={filePreviews}
              setFilePreviews={setFilePreviews}
              accept="application/pdf,image/jpeg,image/png"
              disabled={false}
              showMoreButton={true}
              // showInstruction={true}
              modeltitle="Document Instruction"
              showBackground={true}
              documents={companyDocuments}
              onDelete={(index) =>
                handleDeleteUploadedDocument(index, "company")
              }
            />
          </Grid>

          <Grid size={{ xs: 12, md: 12 }}>
            <FormInputField
              placeholder="Enter business address"
              formik={formik}
              name="business_address"
              label="Business Address"
              isMulti={true}
              rows={4}
            />
            <Typography
              variant="caption"
              sx={{ color: "#666", fontSize: "14px" }}
            >
              Include Zip Code
            </Typography>
          </Grid>

          <Grid size={{ xs: 12, md: 12 }}>
            <FormInputField
              placeholder="Enter nature of business"
              formik={formik}
              name="nature_of_business"
              label="Nature of Business"
            />
            <Typography
              variant="caption"
              sx={{ color: "#666", fontSize: "14px" }}
            >
              We will find the NAICS code of your nature of the business. Please
              describe your business clearly.
            </Typography>
          </Grid>

          <Grid size={{ xs: 12, md: 12 }}>
            <StyledTypographyLLc isFont={true}>EIN</StyledTypographyLLc>
            {/* <UploadMultipleFile
              title={""}
              placeholder="Upload Documents"
              name="ein_document"
              formik={formik}
              icon={<UploadIcon />}
              filePreviews={einPreviews}
              setFilePreviews={setEinPreviews}
              accept="application/pdf,image/jpeg,image/png"
              disabled={false}
              showMoreButton={true}
              // showInstruction={true}
              modeltitle="Document Instruction"
              showBackground={true}
            /> */}
            <UploadFileFieldNew
              title={""}
              icon={<UploadIcon />}
              name="ein_document"
              formik={formik}
              handleFileChange={(e) =>
                handleFileChange(e, "ein_document", setEinPreviews)
              }
              setFilePreview={setEinPreviews}
              filePreview={einPreviews}
              // showInstruction
            />
          </Grid>

          <Grid size={{ xs: 12, md: 12 }}>
            <StyledTypographyLLc isFont={true}>
              ITIN (If you have one){" "}
              <span
                style={{ color: "#666", fontSize: "12px", marginLeft: "10px" }}
              >
                optional
              </span>
            </StyledTypographyLLc>
            <UploadMultipleFile
              title={""}
              placeholder="Upload Documents"
              name="itin_document"
              formik={formik}
              icon={<UploadIcon />}
              filePreviews={itinPreviews}
              setFilePreviews={setItinPreviews}
              accept="application/pdf,image/jpeg,image/png"
              disabled={false}
              showMoreButton={true}
              // showInstruction={true}
              modeltitle="Document Instruction"
              showBackground={true}
              documents={itinDocuments}
              onDelete={(index) => handleDeleteUploadedDocument(index, "itin")}
            />
          </Grid>

          {/* BUSINESS INCOME DETAILS */}

          <Grid size={{ xs: 12, md: 12 }}>
            <StyledTypographyLLc isFont={true}>
              BUSINESS INCOME DETAILS (Please leave all O if you choose 5472 and
              1120 proforma)
            </StyledTypographyLLc>
            <FormInputField
              placeholder=""
              formik={formik}
              name="gross_income"
              label="Gross Income (USD)"
              type="number"
            />
          </Grid>
          <Grid size={{ xs: 12, md: 12 }}>
            <FormInputField
              placeholder=""
              formik={formik}
              name="amount_of_returns"
              label="Amount of Returns (USD)"
              type="number"
            />
            <Typography
              variant="caption"
              sx={{ color: "#666", fontSize: "12px" }}
            >
              Please provide the amount you did not get the payment for the
              services you provided. You can leave as ZERO if you do not have.
            </Typography>
          </Grid>

          <Grid size={{ xs: 12, md: 12 }}>
            <FormInputField
              placeholder=""
              formik={formik}
              name="cost_of_goods_sold"
              label="Amount of Cost of Goods Sold (USD)"
              type="number"
            />
            <Typography
              variant="caption"
              sx={{ color: "#666", fontSize: "12px" }}
            >
              Please provide amount you paid for the products your business has
              bought during 2022. You can leave as ZERO if you do not have.
            </Typography>
          </Grid>

          {/* BUSINESS EXPENSE DETAILS */}

          <StyledTypographyLLc isFont={true} sx={{ marginBottom: "-13px" }}>
            BUSINESS EXPENSE DETAILS (Please leave all 0 If you choose 5472 and
            1120 performa)
          </StyledTypographyLLc>
          {businessExpenses.map((expense, index) => (
            <Grid key={index} size={{ xs: 12, md: 12 }}>
              <FormInputField
                placeholder="Enter amount"
                formik={formik}
                name={expense.name}
                label={expense.label}
                type="number"
              />
              <Typography
                variant="caption"
                sx={{ color: "#666", fontSize: "12px" }}
              >
                {expense.hint}
              </Typography>
            </Grid>
          ))}

          {/* PERSONAL INCOME */}
          <StyledTypographyLLc isFont={true} sx={{ marginBottom: "-13px" }}>
            PERSONAL INCOME Details (Please fill here only if you have any
            additional income besides your US business)
          </StyledTypographyLLc>

          {personalIncomeFields.map((field, index) => (
            <Grid key={index} size={{ xs: 12, md: 12 }}>
              <FormInputField
                placeholder="Enter amount"
                formik={formik}
                name={field.name}
                label={field.label}
                type="number"
              />
              <Typography
                variant="caption"
                sx={{ color: "#666", fontSize: "12px" }}
              >
                {field.hint}
              </Typography>
            </Grid>
          ))}

          {/* CONTRIBUTIONS AND DISTRIBUTIONS */}

          <Grid size={{ xs: 12, md: 12 }}>
            <StyledTypographyLLc isFont={true}>
              CONTRIBUTIONS AND DISTRIBUTIONS (Leave 0 if the numbers are 0))
            </StyledTypographyLLc>
            <FormInputField
              placeholder="Enter total contributions"
              formik={formik}
              name="total_contributions"
              label="Total Contributions"
              type="number"
            />
            <Typography
              variant="caption"
              sx={{ color: "#666", fontSize: "12px" }}
            >
              Please put the total amount of money you put into your business
              from your home country or your residence bank. This is not your
              revenue.
            </Typography>
          </Grid>

          <Grid size={{ xs: 12, md: 12 }}>
            <FormInputField
              placeholder="Enter total distributions"
              formik={formik}
              name="total_distributions"
              label="Total Distributions"
              type="number"
            />
            <Typography
              variant="caption"
              sx={{ color: "#666", fontSize: "12px" }}
            >
              Please put the total amount of money you took out of your business
              from your home country or your residence bank. This is not your
              expense.
            </Typography>
          </Grid>

          {/* Submit Button */}
          <Grid
            size={{ xs: 12, md: 12 }}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <CustomButton
              btnTitle="Review"
              type="submit"
              loading={loading || isSavingDraft}
              // handleClick={() => {
              //  formik.handleSubmit();
              // }}
            />
          </Grid>
        </StyledGrid>
      </form>
      {/* } */}
      <CopyModel
        open={isTaxModalOpen}
        handleClose={handleTaxModalClose}
        taxfillingOrderList={newfetchListOrder}
      />
      {/* <CommonTaxModal isOpen={isTaxModalOpen} handleClose={() => setIsTaxModalOpen(false)} /> */}
    </>
  );
};

export default SinglememberForm;
